export const environment = {
  production: true,
  brands: {
    enelx: {
      baseUrl: 'https://ops-stream.apps.enelx.com/v1/api',
      globalNavUrl: 'https://global-nav.svcs.enelx.net/api/v1',
    },
  },
  cdn: 'https://cdn.apps.enelx.com',
  defaults: {
    brand: 'enelx',
    locale: 'en-us',
    apiLocale: 'en_US',
  },
};
